// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonSwitch_container__2BfrK","basicButton":"ButtonSwitch_basicButton__2BfF-","selected":"ButtonSwitch_selected__1eDAV","unSelected":"ButtonSwitch_unSelected__2ISJp"};